import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useCollectionsQuery } from '@/features/collections/hooks/useCollectionsQuery';
import { usePagesMetadata } from '@/features/pages/hooks/usePagesMetadata';
import { useAppInitializer } from '@/shared/hooks/useAppInitializer';

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const location = useLocation();
  useAppInitializer();
  const warmLocalData = !location.pathname.includes('/shared');

  usePagesMetadata({ enabled: warmLocalData });
  useCollectionsQuery('all', undefined, { enabled: warmLocalData });

  return <>{children}</>;
};
